module.exports = __webpack_public_path__ + "media/images/short_scenario_contest/mockup-f33ce702a13de374b5b342fbd4ef5d35.png";